import React, { useCallback, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { routes } from '@/config';
import { useFormSettingsTrackingData, useJobGlobalIdValue } from '@/domain/job-application/contexts';
import { useAddUpdateProfileSuccessTrackingParam, useIsUpdateProfileEnabled } from '@/domain/job-application/hooks';
import { useLoginStates, useTrackNwtViewedScreen } from '@/hooks';

import { SubmitConfirmationLi as SubmitConfirmationLiWithoutUpdateCV } from './submit-confirmation-li';
import { SubmitConfirmationLiUpdateProfileCv } from './submit-confirmation-li-update-profile-cv';
import { SubmitConfirmationLo } from './submit-confirmation-lo';

export const SubmitConfirmation: React.VFC = () => {
  const history = useHistory();
  const { isLoggedIn } = useLoginStates();
  const { params } = useRouteMatch<{ slug: string }>();
  const jobGlobalId = useJobGlobalIdValue();
  const isUpdateProfileEnabled = useIsUpdateProfileEnabled();
  const onClose = useCallback(
    (): void => history.replace(`${routes.jobs}/${params.slug}?sc_o=jobs_apply_complete_exit`),
    [history, params.slug]
  );
  const formSettingsTrackingProp = useFormSettingsTrackingData();

  const SubmitConfirmationLi = isUpdateProfileEnabled
    ? SubmitConfirmationLiUpdateProfileCv
    : SubmitConfirmationLiWithoutUpdateCV;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useAddUpdateProfileSuccessTrackingParam();

  useTrackNwtViewedScreen({
    page: 'jobs/apply',
    context: 'instant_apply',
    event: 'applied',
    item_urn: jobGlobalId,
    flags: formSettingsTrackingProp,
  });

  return isLoggedIn ? <SubmitConfirmationLi onClose={onClose} /> : <SubmitConfirmationLo onClose={onClose} />;
};
